import { createTheme, Theme } from "@mui/material/styles"
import "lib/material-ui/expanded-theme"

const theme: Theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "Vazirmatn, Arial, sans-serif",
    htmlFontSize: 18
  },
  spacing: 4,
  palette: {
    primary: {
      1: "#FCF9FF",
      2: "#EEE7F6",
      3: "#DDCEEC",
      4: "#BC9DDA",
      5: "#8954BE",
      6: "#560BA2",
      7: "#460982",
      8: "#340761",
      9: "#2C0651",
      10: "#230441",
      500: "#560BA2"
    },
    gray: {
      1: "#FFFFFF",
      2: "#FDFDFD",
      3: "#FAFAFA",
      4: "#F7F7F7",
      5: "#F3F3F3",
      6: "#F1F1F1",
      7: "#EBEBEB",
      8: "#E3E3E3",
      9: "#D4D4D4",
      10: "#CCCCCC",
      11: "#B5B5B5",
      12: "#8A8A8A",
      13: "#616161",
      14: "#4A4A4A",
      15: "#303030",
      16: "#1A1A1A",
      main: "#EBEBEB",
      contrastText: "#4A4A4A"
    },
    success: {
      1: "#dff2f0",
      2: "#9CC5BF",
      3: "#6DA69E",
      4: "#33897D",
      500: "#33897D"
    },
    warning: {
      1: "#FEF6E4",
      2: "#FDEBBF",
      3: "#FFDB85",
      4: "#FBBB22",
      500: "#FBBB22"
    },
    error: {
      1: "#FFECEB",
      2: "#F9D2CE",
      3: "#ED796D",
      4: "#E74C3C",
      500: "#E74C3C"
    },
    info: {
      1: "#EBF4FF",
      2: "#BFDEFF",
      3: "#75B0F0",
      4: "#2970BE",
      500: "#2970BE"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-text.Mui-disabled": {
            background: "transparent",
            color: "#CCCCCC"
          },
          "&.MuiButton-textInherit": {
            background: "transparent",
            color: "#FFFFFF"
          },
          "&.MuiButton-contained.Mui-disabled": {
            background: "#E3E3E3",
            color: "#FFFFFF"
          },
          "&.MuiButton-contained.MuiLoadingButton-root.MuiLoadingButton-loading": {
            background: "#E3E3E3",
            color: "#FFFFFF"
          },
          "&.MuiButton-containedInherit": {
            background: "#FFFFFF",
            color: "#560BA2"
          }
        }
      }
    }
  }
})

export default theme
